export function lsgetItem(param) {
    let user = localStorage.getItem(param) ? JSON.parse(localStorage.getItem(param)) : null;
/*     if(!encodedUser) return null;
    let user = JSON.parse(atob(encodedUser)); */
    return user;
}

export function lssetItem(user,param) {
    let strUser = JSON.stringify(user);
/*     let encodedUser = btoa(strUser); */
    localStorage.setItem(param, strUser);
}